<div [ngSwitch]="this.redirectRoute || this.currentRoute">
  <app-logo-header 
    *ngSwitchDefault
    [showSimpleLogo]="showHeaderLogo"
    [showSignOutButton]="showSignOutButton">
  </app-logo-header>
</div>
<app-toast-pop-up></app-toast-pop-up>
<app-loader-screen 
  [isLoading]="loaderService.isLoading">
</app-loader-screen>
<router-outlet></router-outlet>